// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "javascript/chunks/" + "48aab5ba4782eb3fa960" + ".min.js";
};